import { TextField, Select, MenuItem, Grid, Typography, Box, ButtonBase } from '@mui/material';
import FieldWrapper from '../FieldWrapper';

const STATO_CIVILE = ['Celibe / Nubile', 'Coniugato in Comunione di Beni', 'Coniugato in Separazione di Beni', 'Convivente', 'Separato/a', 'Divorziato/a', 'Vedovo/a'];

export default function Step3Anagrafica({ data, onChange, errors, metadata }) {
  const meta = (f) => metadata?.[f] || {};

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
          I tuoi dati personali
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Inserisci o verifica le informazioni anagrafiche
        </Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FieldWrapper label="Cognome" required error={errors?.cognome} completed={!!data.cognome} locked={meta('cognome').editable === false} source={meta('cognome').source}>
            <TextField fullWidth size="small" value={data.cognome || ''} onChange={e => onChange('cognome', e.target.value)} placeholder="Il tuo cognome" />
          </FieldWrapper>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FieldWrapper label="Nome" required error={errors?.nome} completed={!!data.nome} locked={meta('nome').editable === false} source={meta('nome').source}>
            <TextField fullWidth size="small" value={data.nome || ''} onChange={e => onChange('nome', e.target.value)} placeholder="Il tuo nome" />
          </FieldWrapper>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FieldWrapper label="Data di nascita" required error={errors?.data_nascita} completed={!!data.data_nascita} locked={meta('data_nascita').editable === false} source={meta('data_nascita').source}>
            <TextField fullWidth size="small" type="date" InputLabelProps={{ shrink: true }} value={data.data_nascita || ''} onChange={e => onChange('data_nascita', e.target.value)} />
          </FieldWrapper>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FieldWrapper label="Luogo di nascita" error={errors?.luogo_nascita} completed={!!data.luogo_nascita} locked={meta('luogo_nascita').editable === false} source={meta('luogo_nascita').source}>
            <TextField fullWidth size="small" value={data.luogo_nascita || ''} onChange={e => onChange('luogo_nascita', e.target.value)} placeholder="Comune di nascita" />
          </FieldWrapper>
        </Grid>

        <Grid item xs={12}>
          <FieldWrapper label="Codice Fiscale" required error={errors?.codice_fiscale} completed={!!data.codice_fiscale} locked={meta('codice_fiscale').editable === false} source={meta('codice_fiscale').source} hint="16 caratteri alfanumerici">
            <TextField 
              fullWidth 
              size="small" 
              value={data.codice_fiscale || ''} 
              onChange={e => onChange('codice_fiscale', e.target.value.toUpperCase())} 
              placeholder="RSSMRA85M01H501Z" 
              inputProps={{ maxLength: 16, style: { textTransform: 'uppercase', letterSpacing: '0.1em', fontFamily: 'monospace' } }} 
            />
          </FieldWrapper>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FieldWrapper label="Sesso" required error={errors?.sesso} completed={!!data.sesso}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              {['Maschio', 'Femmina'].map(opt => (
                <ButtonBase
                  key={opt}
                  onClick={() => onChange('sesso', opt)}
                  sx={{
                    flex: 1,
                    py: 1,
                    px: 2,
                    borderRadius: 2,
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    border: '2px solid',
                    transition: 'all 0.2s',
                    borderColor: data.sesso === opt ? 'primary.main' : 'divider',
                    bgcolor: data.sesso === opt ? 'primary.light' : 'transparent',
                    color: data.sesso === opt ? 'primary.main' : 'text.secondary',
                    '&:hover': { borderColor: 'primary.main' }
                  }}
                >
                  {opt}
                </ButtonBase>
              ))}
            </Box>
          </FieldWrapper>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FieldWrapper label="Stato Civile" error={errors?.stato_civile} completed={!!data.stato_civile}>
            <Select 
              fullWidth 
              size="small" 
              value={data.stato_civile || ''} 
              onChange={e => onChange('stato_civile', e.target.value)}
              displayEmpty
            >
              <MenuItem value="" disabled>Seleziona stato civile</MenuItem>
              {STATO_CIVILE.map(opt => (
                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
              ))}
            </Select>
          </FieldWrapper>
        </Grid>
      </Grid>
    </Box>
  );
}